//Built-in libraries
import { ChangeEvent } from "react";

//Third party libraries

//Custom components
import Button from "components/UI/Button";
import Input from "components/UI/Form/Input";
import Modal, { ModalProps } from "components/UI/Modal";
import ReactSelect from "components/UI/Form/ReactSelect";
import { municipalities, potentialProperty } from "./constants";
import { ReactSelectOption } from "types/Constants";
import { States } from "../../../../../../constants";
import RadioGroupInput from "components/UI/Form/RadioGroup";
import Scale from "../Scale";
import { rangeOneToFive } from "../ClientInformation/constants";
import { preliminaryPlan } from "../OrganizationalGoals/constants";
import FileInput from "components/UI/Form/FileInput";

//Services

//Assets andd Miscellaneous

//Component Begin

interface IAddDevelopmentAddressMemberFormProps extends ModalProps {
  modalHandler: () => void;
  address: { [key: string]: { [key: string]: any } };
  inputChangedHandler: (
    value:
      | string
      | number
      | boolean
      | ChangeEvent<HTMLInputElement>
      | undefined
      | null
      | FileList
      | string[],
    name: string
  ) => void;
  onAddAddressHandler: () => void;
  isEditing: boolean;
  updateAddressHandler: () => void;
}

export default function AddRealEstateGoalsForm({
  modalHandler,
  isEditing,
  address,
  inputChangedHandler,
  onAddAddressHandler,
  updateAddressHandler,
  ...rest
}: IAddDevelopmentAddressMemberFormProps) {
  return (
    <Modal width="min-w-2/3">
      <h2 className="mt-0 text-lg">{`${
        isEditing ? "Edit" : "Add"
      } Property Address`}</h2>
      <div>
        <section className="space-y-4">
          <div>
            <RadioGroupInput
              label="Property Status"
              id="property-status"
              name="propertyStatus"
              options={[
                { label: "Structured", value: "Structured" },
                { label: "Vacant Lot", value: "Vacant Lot" },
              ]}
              value={address?.propertyStatus.value}
              error={address?.propertyStatus.error}
              onChange={(value) => {
                inputChangedHandler(value, "propertyStatus");
              }}
            />
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div className="col-span-3">
              <Input
                label="Street Address"
                id="street-address"
                name="streetAddress"
                className="w-1/2"
                type="text"
                value={address?.streetAddress.value}
                error={address?.streetAddress?.error}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  inputChangedHandler(e.target.value, e.target.name);
                }}
                onBlur={(e: ChangeEvent<HTMLInputElement>) => {
                  inputChangedHandler(e.target.value, e.target.name);
                }}
              />
            </div>
            <Input
              label="City"
              id="city"
              name="city"
              type="text"
              value={address?.city.value}
              error={address?.city.error}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                inputChangedHandler(e.target.value, e.target.name);
              }}
              onBlur={(e: ChangeEvent<HTMLInputElement>) => {
                inputChangedHandler(e.target.value, e.target.name);
              }}
            />

            <div>
              <ReactSelect
                label="State"
                name="state"
                options={States.map((s) => ({ label: s.name, value: s.name }))}
                value={{
                  label: address?.state.value,
                  value: address?.state.value,
                }}
                onChange={(option) => {
                  const reactSelectOption = option as ReactSelectOption;

                  inputChangedHandler(reactSelectOption.value, "state");
                }}
              />
            </div>
            <Input
              label="Zip/Postal Code"
              id="zipCode"
              name="zipCode"
              type="text"
              value={address?.zipCode.value}
              error={address?.zipCode.error}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                inputChangedHandler(e.target.value, e.target.name);
              }}
              onBlur={(e: ChangeEvent<HTMLInputElement>) => {
                inputChangedHandler(e.target.value, e.target.name);
              }}
            />
            <div className="col-span-2">
              <ReactSelect
                label="Is the property of interest in any of these municipalities?"
                name="municipality"
                options={municipalities.map((s) => ({
                  label: s,
                  value: s,
                }))}
                value={{
                  label: address?.municipality.value,
                  value: address?.municipality.value,
                }}
                onChange={(option) => {
                  const reactSelectOption = option as ReactSelectOption;
                  inputChangedHandler(reactSelectOption.value, "municipality");
                }}
              />
            </div>
            <div className="col-span-2">
              <ReactSelect
                label="Do you have a preliminary plan for how you would like to utilize this land?"
                name="landUtilizationPlan"
                options={preliminaryPlan.map((s) => ({
                  label: s,
                  value: s,
                }))}
                value={{
                  label: address?.landUtilizationPlan.value,
                  value: address?.landUtilizationPlan.value,
                }}
                onChange={(option) => {
                  const reactSelectOption = option as ReactSelectOption;

                  inputChangedHandler(
                    reactSelectOption.value,
                    "landUtilizationPlan"
                  );
                }}
              />
            </div>

            {/* <div className="col-span-2">
              <FileInput
                id="property-photo"
                name="propertyPhoto"
                type="file"
                label="Do you have any photos of the property of interest?"
                multiple
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  const total = {
                    ...address?.propertyPhoto?.value,
                    e: e.target.files,
                  };
                  inputChangedHandler(e.target.files, e.target.name);
                }}
              />
            </div> */}

            <div className="col-span-2">
              <ReactSelect
                label="Is the property any of the following?"
                name="propertyType"
                options={potentialProperty.map((s) => ({
                  label: s,
                  value: s,
                }))}
                value={{
                  label: address?.propertyType.value,
                  value: address?.propertyType.value,
                }}
                onChange={(option: any) => {
                  const reactSelectOption = option as ReactSelectOption;
                  inputChangedHandler(reactSelectOption.value, "propertyType");
                }}
              />
            </div>

            <div className="col-span-3">
              <RadioGroupInput
                label="Are you aware of any outstanding code violations or municipal liens on the property(s) of interest?"
                id="code-violation"
                name="codeViolation"
                options={[
                  { label: "Yes", value: "yes" },
                  { label: "No", value: "no" },
                ]}
                value={address?.codeViolation.value}
                error={address?.codeViolation.error}
                onChange={(value) => {
                  inputChangedHandler(value, "codeViolation");
                }}
              />
            </div>
            <div className="col-span-2">
              <RadioGroupInput
                label="Have you talked with your CDC/RCO to confirm that this property is available?"
                id="confirm-property"
                name="confirmProperty"
                options={[
                  { label: "Yes", value: "yes" },
                  { label: "No", value: "no" },
                ]}
                value={address?.confirmProperty.value}
                error={address?.confirmProperty.error}
                onChange={(value) => {
                  inputChangedHandler(value, "confirmProperty");
                }}
              />
            </div>

            <div className="col-span-2">
              <Scale
                title="Please describe the current condition of property"
                name="propertyCurrentCondition"
                range={rangeOneToFive}
                value={address?.propertyCurrentCondition.value}
                onChange={(value) => {
                  inputChangedHandler(value, "propertyCurrentCondition");
                }}
              />
            </div>
            <div className="col-span-3">
              <div className="my-5">
                <h4 className="text-base">
                  Are the following up to date on this property?
                </h4>
              </div>

              <RadioGroupInput
                label="Property taxes"
                id="property-taxes"
                name="propertyTaxes"
                options={[
                  { label: "Yes", value: "yes" },
                  { label: "No", value: "no" },
                  { label: `Don't Know`, value: `don't know` },
                ]}
                value={address?.propertyTaxes.value}
                error={address?.propertyTaxes.error}
                onChange={(value) => {
                  inputChangedHandler(value, "propertyTaxes");
                }}
              />
              <RadioGroupInput
                label="Water Bills"
                id="water-bills"
                name="waterBills"
                options={[
                  { label: "Yes", value: "yes" },
                  { label: "No", value: "no" },
                  { label: `Don't Know`, value: `don't know` },
                ]}
                value={address?.waterBills.value}
                error={address?.waterBills.error}
                onChange={(value) => {
                  inputChangedHandler(value, "waterBills");
                }}
              />
              <RadioGroupInput
                label="Sewage Bills"
                id="sewage-bills"
                name="sewageBills"
                options={[
                  { label: "Yes", value: "yes" },
                  { label: "No", value: "no" },
                  { label: `Don't Know`, value: `don't know` },
                ]}
                value={address?.sewageBills.value}
                error={address?.sewageBills.error}
                onChange={(value) => {
                  inputChangedHandler(value, "sewageBills");
                }}
              />
              <RadioGroupInput
                label="Refuse Bills"
                id="refuse-bills"
                name="refuseBills"
                options={[
                  { label: "Yes", value: "yes" },
                  { label: "No", value: "no" },
                  { label: `Don't Know`, value: `don't know` },
                ]}
                value={address?.refuseBills.value}
                error={address?.refuseBills.error}
                onChange={(value) => {
                  inputChangedHandler(value, "refuseBills");
                }}
              />
            </div>
            <div className="col-span-2">
              <h6 className="my-4">
                Describe any changes or improvements you will make to the
                condition of the property.
              </h6>
              <textarea
                id="conditionUpgradeStrategy"
                name="conditionUpgradeStrategy"
                rows={4}
                className="p-3 shadow-sm block w-full sm:text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primaryColor-normal"
                value={address?.conditionUpgradeStrategy.value}
                onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                  inputChangedHandler(
                    e.target.value,
                    "conditionUpgradeStrategy"
                  );
                }}
              />
            </div>
          </div>
        </section>
        <div className="flex justify-end gap-4 mt-10">
          <Button
            disabled={false}
            label="Cancel"
            type="button"
            btnStyle="neutral"
            onClick={modalHandler}
          />
          <Button
            label={`${isEditing ? "Save" : "Add"}`}
            type="button"
            btnStyle="primary"
            onClick={isEditing ? updateAddressHandler : onAddAddressHandler}
          />
        </div>
      </div>
    </Modal>
  );
}
